/**
 * <recently-viewed> custom element.
 *
 * Records the current product (when present) into sessionStorage as a
 * deduped, capped list of IDs. Fetches /search?section_id=...&q=id:N+OR+...
 * to render previously-viewed products via the same section template.
 */
(function () {
  const STORAGE_KEY = "eksRecentProducts";
  const MAX = 12;

  function readList() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed)
        ? parsed.filter((id) => Number.isInteger(id))
        : [];
    } catch {
      return [];
    }
  }

  function writeList(list) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    } catch {}
  }

  function record(currentId) {
    if (!currentId) return readList();
    const id = parseInt(currentId, 10);
    if (!Number.isInteger(id)) return readList();
    let list = readList().filter((x) => x !== id);
    list.unshift(id);
    if (list.length > MAX) list = list.slice(0, MAX);
    writeList(list);
    return list;
  }

  class RecentlyViewed extends HTMLElement {
    connectedCallback() {
      const currentId = this.dataset.currentProductId;
      const list = record(currentId);
      const sectionId = this.dataset.sectionId;
      const limit = parseInt(this.dataset.limit, 10) || 4;

      // Exclude current product from the list shown
      const ids = list
        .filter((id) => String(id) !== String(currentId))
        .slice(0, limit);
      if (!ids.length) return;

      const query = ids.map((id) => `id:${id}`).join(" OR ");
      const url = `/search?section_id=${sectionId}&type=product&q=${encodeURIComponent(query)}`;

      fetch(url)
        .then((res) => res.text())
        .then((text) => {
          const html = new DOMParser().parseFromString(text, "text/html");
          const incoming = html.querySelector("recently-viewed");
          if (incoming && incoming.innerHTML.trim().length) {
            this.innerHTML = incoming.innerHTML;
            this.hidden = false;
          }
        })
        .catch((err) => console.error("[recently-viewed]", err));
    }
  }

  if (!customElements.get("recently-viewed")) {
    customElements.define("recently-viewed", RecentlyViewed);
  }
})();
